var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"fill":"#3873b0","key":0}),React.createElement("path",{"d":"m13.95128,10.14429L22.67816,0h-2.06799l-7.57755,8.80815L6.98046,0H0l9.15206,13.31948L0,23.95732h2.06811l8.00209-9.3017,6.39153,9.3017h6.98046l-9.49141-13.81303h.00051Zm-2.83256,3.29253l-.92729-1.32632L2.81328,1.55684h3.17649l5.95426,8.51714.92729,1.32632,7.73983,11.07098h-3.17649l-6.31593-9.03395v-.00051Z","key":1})]);
}

TwitterInline.defaultProps = {"width":"32","height":"28","viewBox":"0 0 23.44218 23.95732","fill":"#3873b0"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
